import type { AnalyticsVerificationsWidgetCallToAction } from 'src/modules/analytics/types';

import type { VerificationsNudge as Nudge } from '../types';

import { OpenDetailsNudge } from './OpenDetailsNudge';
import { SeekPassDialogNudge } from './SeekPassDialogNudge';

interface NudgeProps {
  nudge: Nudge;
  openVerifiableTab: () => void;
  analyticsOnClick: (props: {
    callToAction: AnalyticsVerificationsWidgetCallToAction;
  }) => void;
}

export const VerificationsNudge = ({
  nudge,
  openVerifiableTab,
  analyticsOnClick,
}: NudgeProps) => {
  if (nudge.__typename === 'VerificationsOpenDetailsNudge') {
    return (
      <OpenDetailsNudge
        buttonOnClick={openVerifiableTab}
        analyticsOnClick={analyticsOnClick}
      />
    );
  }
  if (nudge.__typename === 'VerifiableCredentialNudge2') {
    return (
      <SeekPassDialogNudge
        credential={nudge.credential}
        analyticsOnClick={analyticsOnClick}
      />
    );
  }
  return null;
};
